import { useHistory } from 'react-router-dom';
import { useDispatch, batch } from 'react-redux';
import * as Sentry from '@sentry/react';

import { REMOVE_USER, setUserReady } from '../actions/userActions';
import { removeItem } from '../helpers/store';
import { trackEvent, reset as analyticsReset } from '../helpers/analytics';
import { restartChat } from '../helpers/supportChat';
import { useSignOutMutation } from '../services/auth';
import { useResetCache } from './useResetCache';
import { setNetworksReady } from '../actions/networksActions';
import { signOutBrowserExtension } from '../services/chromeExtension';

export const useSignOut = () => {
  const [signOutMutation, { isLoading }] = useSignOutMutation();
  const resetCache = useResetCache();
  const history = useHistory();
  const dispatch = useDispatch();

  const signOut = () => {
    trackEvent('user_logged_out');

    const findemAuthBaseUrl = import.meta.env.VITE_FINDEM_AUTH_BASE_URL;
    if (findemAuthBaseUrl) {
      fetch(`${findemAuthBaseUrl}/auth/logout?api=1`, {
        credentials: 'include',
        keepalive: true,
      }).catch(() => {});
    }

    signOutMutation().then(() => {
      signOutBrowserExtension();
      removeItem('authToken');
      batch(() => {
        dispatch({ type: REMOVE_USER });
        dispatch(setUserReady(true));
        dispatch(setNetworksReady(true));
      });
      analyticsReset();
      Sentry.configureScope((scope) => scope.setUser(null));
      resetCache();
      restartChat();
      window.CommandBar?.shutdown();
      history.push('/login');
    });
  };

  return { signOut, isLoading };
};
